import { format, formatDistanceToNow } from "date-fns";

export function formatRelative(iso?: string | null) {
  if (!iso) return "";
  try {
    return formatDistanceToNow(new Date(iso), { addSuffix: true });
  } catch {
    return "";
  }
}

export function formatAbsolute(iso?: string | null) {
  if (!iso) return undefined;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? undefined : d.toLocaleString();
}

/** "Oct 22, 2026 at 3:04 PM" (local time); "" when missing or invalid. */
export function formatDateTime(iso?: string | null) {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : format(d, "MMM d, yyyy 'at' h:mm a");
}

/** "Oct 22, 2026" (local time); "" when missing or invalid. */
export function formatDate(iso?: string | null) {
  if (!iso) return "";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? "" : format(d, "MMM d, yyyy");
}

export function extractAxiosDetail(e: unknown): string {
  if (e && typeof e === "object" && "response" in e) {
    const d = (e as { response?: { data?: { detail?: unknown } } }).response?.data?.detail;
    if (typeof d === "string") return d;
    if (Array.isArray(d)) {
      return d
        .map((x) => (x && typeof x === "object" && "msg" in x ? String((x as { msg: unknown }).msg) : String(x)))
        .join(", ");
    }
  }
  if (e instanceof Error) return e.message;
  return "Something went wrong.";
}

/** "salaried_manager" -> "Salaried manager", "hourly" -> "Hourly". */
export function humanizeToken(value: string) {
  const spaced = value.replace(/[_-]+/g, " ").trim().toLowerCase();
  return spaced ? spaced.charAt(0).toUpperCase() + spaced.slice(1) : value;
}

export function fullName(first?: string | null, last?: string | null, fallback = "—") {
  const name = `${first ?? ""} ${last ?? ""}`.trim();
  return name || fallback;
}
